import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import moment from 'moment';

import ModalBoxes from '../../../../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../../../../../constants/dateFormat';
import { muiDataGridLocaleText } from '../../../../../../../../../../services/i18n/mui';
import { DefaultFinanceCell } from '../../../../../../../../finance/shared/FinanseTableMUI/DefaultFinanceCell';
import { convertPatientStatus } from '../../../../../../../../finance/SiteFinance/SiteFinanceTable/SiteFinanceTable';
import { dateValueGetterWithoutLocalTimezone } from '../../../../../../../Patients/Logs/LinkLogRecord/LinkLogRecordModal/ParticipantTable/ParticipantTable';

import './LinkedParticipantsModal.scss';

export const LinkedParticipantsModal = ({
  participants = [],
  showPatientColumn = false,
  generateUrlToPatientInfoPage
}) => {
  const columns = useMemo(() => {
    const columns = [
      {
        field: 'patientFullName',
        headerName: 'Patient',
        minWidth: 150,
        flex: 1,
        valueGetter: (value, row) => `${row.firstName} ${row.lastName}`,
        renderCell: ({ row, value }) => (
          <Link onClick={() => ModalBoxes.closeAll()} to={generateUrlToPatientInfoPage(row)}>
            {value}
          </Link>
        )
      },
      {
        field: 'patientId',
        headerName: 'Patient ID',
        minWidth: 150,
        flex: 1,
        renderCell: DefaultFinanceCell
      },
      {
        field: 'subjectId',
        headerName: 'Subject ID',
        minWidth: 150,
        flex: 1,
        renderCell: DefaultFinanceCell
      },
      {
        field: 'patientStatus',
        headerName: 'Current Patient Status',
        valueGetter: value => convertPatientStatus(value),
        minWidth: 150,
        flex: 1,
        renderCell: DefaultFinanceCell
      },
      {
        field: 'icfConsentSignedDate',
        headerName: 'Date ICF Signed',
        type: 'date',
        valueGetter: dateValueGetterWithoutLocalTimezone,
        renderCell: ({ value }) => <div>{value ? moment(value).format(DD_SLASH_MMM_SLASH_YYYY) : '—'}</div>,
        minWidth: 150,
        flex: 1
      }
    ];
    return showPatientColumn ? columns : columns.filter(column => column.field !== 'patientFullName');
  }, [generateUrlToPatientInfoPage, showPatientColumn]);

  return (
    <ModalBoxes.Body>
      <DataGridPremium
        slotProps={{ root: { 'data-testid': 'linked-participants-table' } }}
        sx={{
          border: 'none',
          height: 'auto'
        }}
        getRowId={row => row?.ssuPatientId}
        rows={participants}
        columns={columns}
        rowHeight={38}
        localeText={muiDataGridLocaleText({ noRowsLabel: 'No Record Found' })}
        disableRowGrouping
        disableAggregation
        disablePivoting
        disableRowSelectionOnClick
      />
    </ModalBoxes.Body>
  );
};
